import { render, staticRenderFns } from "./AppInfoModal.vue?vue&type=template&id=a2816836&scoped=true&"
import script from "./AppInfoModal.vue?vue&type=script&lang=js&"
export * from "./AppInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./AppInfoModal.vue?vue&type=style&index=0&id=a2816836&scoped=true&lang=scss&"
import style1 from "./AppInfoModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2816836",
  null
  
)

export default component.exports